// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change-height-down{height:250px!important}.change-height-down,.change-height-up{-webkit-transition:.7s!important;transition:.7s!important}.change-height-up{height:120px!important}.zoom{-webkit-transition:-webkit-transform .5s;transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}@media screen and (min-width:960px){.zoom:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}}", ""]);
// Exports
module.exports = exports;
